import { Subscription } from 'rxjs';
import { MerchantsComponent } from './../merchants/merchants.component';
import { Component, OnInit, OnDestroy, Input, Injector } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-merchant-history',
  templateUrl: './merchant-history.component.html',
  styleUrls: ['./merchant-history.component.css']
})
export class MerchantHistoryComponent
  extends MerchantsComponent
  implements OnDestroy, OnInit
{
  dataLoading = false;
  showAllTrans = false;
  acctFilter = false;
  acctSelected = '';
  stripAccount: any = null;
  customerAccounts: any[] = [];
  transactions: any[] = [];
  identity: any = null;
  filterTrans = [];
  applyReverseButtonSpinnerString = '';
  startDate: NgbDate;
  endDate: NgbDate;
  merchantDataSub: Subscription = null;
  merchantTransSub: Subscription = null;
  transactionDateRange = 35; // This should reflex what is in TransactionController.java

  static format(date: NgbDate) {
    return (
      ('0' + date.month).slice(-2) +
      '/' +
      ('0' + date.day).slice(-2) +
      '/' +
      date.year
    );
  }

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    this.dataLoading = true;
    this.endDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - this.transactionDateRange);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      startDateWork.getDate()
    );
    this.merchantAccountInfoSet.subscribe(() => {
      this.customerAccounts = this.merchantAccountInfo.customerAccounts;
      this.stripAccount = this.merchantAccountInfo.customerAccounts[0];
      this.refreshMerchantTransactionData();
    });
  }

  refreshMerchantTransactionData() {
    const startDateString = MerchantHistoryComponent.format(this.startDate);
    const endDateString = MerchantHistoryComponent.format(this.endDate);
    this.dataLoading = true;
    this.filterTrans = [];
    const chipAccount = this.merchantAccountInfo.customerAccounts.slice(
      1,
      this.merchantAccountInfo.customerAccounts.length
    );
    this.merchantTransSub = this.merchantService
      .getMerchantTransactions(
        this.stripAccount.account,
        chipAccount[0].account,
        startDateString,
        endDateString
      )
      .subscribe(
        (results) => {
          results.transactions.sort(
            (objA, objB) =>
              new Date(objB.postDate).getTime() -
              new Date(objA.postDate).getTime()
          );
          this.transactions = results.transactions;
          this.filterTrans = this.transactions;
          this.dataLoading = false;
        },
        (error) => {
          console.log(error);
          this.dataLoading = false;
        }
      );
  }

  reverse(transaction: any) {
    this.dataLoading = true;
    const that = this;
    this.cardHolderService.reverse(transaction.tranSequence).subscribe(
      () => {
        transaction.reverseState = -1;
        this.messageService.success('Reversal Successful');
        this.refreshMerchantTransactionData();
        this.dataLoading = false;
      },
      (error) => {
        that.messageService.error(error.error);
      }
    );
  }

  getSelectedTransHistory(eve) {
    this.filterTrans = [];
    const arr = [];
    const account = eve.target.value;
    if (account === '') {
      this.filterTrans = this.transactions;
    } else {
      this.transactions.forEach(function (trans) {
        if (trans.account === +account) {
          arr.push(trans);
        }
      });
      this.filterTrans = arr;
    }
  }

  ngOnDestroy(): void {
    if (this.merchantTransSub !== null) {
      this.merchantTransSub.unsubscribe();
    }
  }

  showDetails(expandedTrans: object) {
    expandedTrans['c2cDetails'] = '';
    let details: string[];
    const tranDetails = new Object();
    details = expandedTrans['typeDescription'].split('\n');

    for (let x = 0; x < details.length; x += 2) {
      tranDetails[details[x]] = details[x + 1];
    }

    if (
      expandedTrans['merchantName'] != null &&
      expandedTrans['merchantName'].trim() != ''
    ) {
      tranDetails['Merchant:'] = expandedTrans['merchantName'];
    }

    if (
      expandedTrans['type'] == '0061' ||
      expandedTrans['type'] == '0260' ||
      expandedTrans['type'] == '0331' ||
      expandedTrans['type'] == '0334'
    ) {
      this.cardHolderService
        .getC2CDetails(
          this.merchant.ncMerchantNum,
          expandedTrans['tranSequence'],
          expandedTrans['type']
        )
        .subscribe(
          (data) => {
            expandedTrans['c2cDetails'] = data.typeDescription;
          },
          (err) => {
            expandedTrans['c2cDetails'] = '';
            console.log(err);
          }
        );
    }
    expandedTrans['tranDetails'] = tranDetails;
  }
}
